import React from 'react';
import { Helmet } from 'react-helmet-async';

// Domínio canônico de produção (o watizap.work é só o ambiente de desenvolvimento).
const SITE = 'https://watizap.com';

/**
 * SEO por rota: dá a cada página pública um título, uma descrição e um canonical
 * próprios, sobrescrevendo os valores fixos do index.html (que valem para a home).
 * Sem isto, o React não troca essas etiquetas ao navegar e o Google trata as
 * páginas internas como cópias da home.
 *
 * Uso: <Seo title="Termos de Uso | Watizap" description="..." path="/termos-de-uso" />
 */
export default function Seo({ title, description, path = '/' }) {
  const url = SITE + path;
  return (
    <Helmet>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={url} />
      {/* Espelha nas metas sociais para o compartilhamento bater com a página. */}
      <meta property="og:title" content={title} />
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      {description ? <meta name="twitter:description" content={description} /> : null}
    </Helmet>
  );
}
